/** **************************************
 * Auto Generated by PermissionGenerator *
 * Don't edit it manually                *
 ****************************************/

export default {
  GLOBAL_AGENCY_MANAGE: 4096,
  GLOBAL_AGENCY_LOGIN_AS: 4112,
  GLOBAL_FREE_LOGIN: 4113,
  GLOBAL_SUPER_CHANNEL_MANAGER: 4114,
  GLOBAL_CHANNEL_MANAGER_MANAGE: 4115,
  GLOBAL_RULE_MANAGE: 4128,
  POSITION_MANAGE: 4352,
  POSITION_VIEW: 4353,
  EMPLOYEE_MANAGE: 4368,
  EMPLOYEE_VIEW: 4369,
  RULE_MANAGE: 4384,
  RULE_VIEW: 4385,
  DOWNLOAD_CONTACT: 4386,
  PERM_AGENCY_DIRECT_SALES_EDIT: 4387,
  LEAD_VIEW_SELF: 4608,
  LEAD_VIEW_GROUP: 4609,
  LEAD_VIEW_ALL: 4610,
  LEAD_VIEW_ALL_PENDING: 4611,
  LEAD_VIEW_ALL_INVALID: 4612,
  LEAD_VIEW_BASIC_SEARCH: 4613,
  LEAD_CREATE: 4624,
  LEAD_EDIT_SELF: 4640,
  LEAD_EDIT_GROUP: 4641,
  LEAD_EDIT_ALL: 4642,
  LEAD_CONVERT_SELF: 4656,
  LEAD_ASSIGN_SELF_TO_LEADER: 4672,
  LEAD_ASSIGN_SELF_TO_ANY: 4673,
  LEAD_ASSIGN_GROUP_TO_GROUP: 4674,
  LEAD_ASSIGN_ANY_TO_ANY: 4675,
  LEAD_CLEAN_SELF: 4688,
  LEAD_CLEAN_ALL_PENDING: 4689,
  LEAD_VIEW_HIGHSEA: 4690,
  LEAD_OBTAIN_TO_SELF: 4691,
  LEAD_OBTAIN_TO_GROUP: 4692,
  LEAD_OBTAIN_TO_ANY: 4693,
  LEAD_RELEASE_SELF: 4694,
  LEAD_RELEASE_GROUP: 4695,
  LEAD_RELEASE_ANY: 4696,
  LEAD_HIGHSEA_ASSIGN_TO_GROUP: 4697,
  LEAD_BASIC_SEARCH_ALL_AGENCY: 4704,
  LEAD_DISTRIBUTE_COMMIT_TO_POOL: 4705,
  LEAD_DISTRIBUTE_COMMIT_TO_AGENCY: 4965, // 线索管理列表-分配给服务商
  DISTRIBUTE_VIEW_SELF_AND_GROUP: 4706, // 服务商-分发池-查看我及我的下属跟进的线索/商机 权限
  DISTRIBUTE_VIEW_ALL: 4707,  // 服务商-分发池-查看所有线索/商机 权限
  DISTRIBUTE_COMMIT_TO_AGENCY: 4708,  // 服务商-分发池-提交分发池线索至服务商权限
  CHECK_NEW_CUSTOM: 4709, // 新客查询工具 orbac 权限
  POTENTIAL_VIEW_SELF: 4864,
  POTENTIAL_VIEW_GROUP: 4865,
  POTENTIAL_VIEW_ALL: 4866,
  POTENTIAL_VIEW_HIGHSEA: 4867,
  POTENTIAL_DOWNLOAD_HIGHSEA: 4868,
  POTENTIAL_EDIT_SELF: 4880,
  POTENTIAL_EDIT_GROUP: 4881,
  POTENTIAL_EDIT_ALL: 4882,
  POTENTIAL_CONVERT_SELF: 4896,
  POTENTIAL_ASSIGN_SELF_TO_LEADER: 4912,
  POTENTIAL_ASSIGN_SELF_TO_ANY: 4913,
  POTENTIAL_ASSIGN_GROUP_TO_GROUP: 4914,
  POTENTIAL_ASSIGN_ANY_TO_ANY: 4915,
  POTENTIAL_OBTAIN_TO_SELF: 4928,
  POTENTIAL_OBTAIN_TO_GROUP: 4929,
  POTENTIAL_OBTAIN_TO_ANY: 4930,
  POTENTIAL_RELEASE_SELF: 4944,
  POTENTIAL_RELEASE_GROUP: 4945,
  POTENTIAL_RELEASE_ANY: 4946,
  POTENTIAL_IS_REVIEW: 4960,
  POTENTIAL_OS_REVIEW: 4961,
  POTENTIAL_HIGHSEA_ASSIGN_TO_GROUP: 4962,
  HIGHSEA_ASSIGN_TO_ANY: 4963,
  DISTRIBUTE_LEAD_OR_POTENTIAL: 4964,
  ORDER_VIEW_SELF: 5120,
  ORDER_VIEW_GROUP: 5121,
  ORDER_VIEW_ALL: 5122,
  ORDER_ASSIGN_SELF_TO_LEADER: 5136,
  ORDER_ASSIGN_SELF_TO_ANY: 5137,
  ORDER_ASSIGN_GROUP_TO_GROUP: 5138,
  ORDER_ASSIGN_ANY_TO_ANY: 5139,
  ORDER_EDIT_SELF: 5152,
  ORDER_EDIT_GROUP: 5153,
  ORDER_EDIT_ALL: 5154,
  ORDER_PAYMENT_REVIEW: 5168,
  ORDER_ONLINE_REVIEW: 5169,
  ORDER_REJECT: 5170,
  CHANNEL_ORDER_IMPORT: 5171,
  CHANNEL_ORDER_DOWNLOAD: 5156,
  ADD_UPDATE_HOUSE_RELATIONSHIP: 5157,
  REPORT_TRAFFIC_REPORT: 5376,
  REPORT_SALES_PERFORMANCE_REPORT: 5392,
  REPORT_SALES_MONITOR_REPORT: 5400,
  REPORT_SALES_PROGRESS_REPORT: 5408,
  REPORT_COST_REPORT_VIEW_ALL: 5424,
  REPORT_COST_REPORT_VIEW_SELF_OR_GROUP: 5425,
  REPORT_RECHARGE_REPORT_VIEW_ALL: 5440,
  REPORT_RECHARGE_REPORT_VIEW_SELF_OR_GROUP: 5441,
  REPORT_PERFORMANCE_ANALYSIS_REPORT_VIEW_COST_FIELD: 5456,
  REPORT_PERFORMANCE_ANALYSIS_REPORT_VIEW_ALL: 5457,
  REPORT_BUSINESS_ANALYSIS_REPORT_VIEW_ALL: 5473,
  REPORT_LEAD_ANALYSIS_REPORT_VIEW_ALL: 5474,
  REPORT_LEAD_ANALYSIS_REPORT_VIEW_SELF_OR_GROUP: 5475,
  REPORT_RECORDING_DOWNLOAD: 5476,
  REPORT_SEAT_ANALYSIS_REPORT_VIEW_ALL: 5479,
  ACCESS_CONTROL_LOGIN: 5632,
  ACCESS_CONTROL_USER_MANAGE: 5633,
  ACCESS_CONTROL_ROLE_MANAGE: 5634,
  ACCESS_CONTROL_PERMISSION_MANAGE: 5635,
  ACCESS_CONTROL_VIEW: 5636,
  ORGANIZATION_VIEW: 5637,
  ACCESS_CONTROL_RELEASE_OTHERS_BLACK: 5638,
  ACCESS_CONTROL_ADD_BLACK_VIEW_SELF_BLACK: 5639,
  ACCESS_CONTROL_RELEASE_SELF_BLACK: 5640,
  ACCESS_CONTROL_ADD_BLACK_VIEW_ALL_BLACK: 5641,
  ACCESS_CONTACT_BLACKLIST: 5648,
  OUTSIDE_VIEW_ALL: 5888,
  OUTSIDE_VIEW_GROUP: 5889,
  OUTSIDE_MANAGE: 5890,
  NEIGHBOURHOOD_BASE_VIEW_SELF: 5904,
  NEIGHBOURHOOD_MANAGE: 5905,
  NEIGHBOURHOOD_BASE_VIEW_GROUP: 5906,
  ONLINE_SALES_RELATION_MANAGE_SELF: 6144,
  ONLINE_SALES_RELATION_VIEW_GROUP: 6145,
  ONLINE_SALES_RELATION_VIEW_ALL: 6146,
  ONLINE_SALES_TAG_MANAGER: 6148,
  ONLINE_SALES_TOOL_TAG_MANAGER: 6149,
  MATERIAL_EDIT: 6150,
  MATERIAL_VIEW: 6151,
  GROUP_MESSAGE_EDIT: 6152,
  GROUP_MESSAGE_VIEW: 6153,
  PERM_SALES_PERFORMANCE_TARGET_AGENCY_VIEW_SELF_SUBORDINATES: 6400,  // 服务商-业绩-查看我及我下属的业绩目标 6400
  PERM_SALES_PERFORMANCE_TARGET_AGENCY_VIEW_ALL: 6401,  // 服务商-业绩-查看全部业绩目标 6401
  PERM_SALES_PERFORMANCE_TARGET_AGENCY_SET: 6402,  // 服务商-业绩-设置可查看范围的人员业绩目标 6402
  PERM_SALES_PROCESS_TARGET_AGENCY_VIEW_SELF_SUBORDINATES: 6403,  // 服务商-过程-查看我及我下属的过程目标
  PERM_SALES_PROCESS_TARGET_AGENCY_VIEW_ALL: 6404,  // 服务商-过程-查看全部过程目标 6404
  PERM_SALES_PROCESS_TARGET_AGENCY_SET: 6405,  // 服务商-过程-设置可查看范围的人员过程目标 6405
  PERM_SALES_TARGET_VIEW_SELF: 6406,  // 销售-查看我的目标 6406
  PERM_SALES_TARGET_VIEW_SELF_SUBORDINATES: 6407,  // 销售-查看我及我的下属目标 6407
  PERM_SALES_TARGET_NEW_CUSTOM: 6409,  // 销售-有效新客 6409
  PERM_SALES_TARGET_HANDBOOK: 8230, // 销售-销售宝典 8230
  PERM_ASSEST_ENTRY: 9260, // 资产授权 9260
  CUSTOMER_ACCOUNT_VIEW_AND_ACTION_SELF: 12288,
  CUSTOMER_ACCOUNT_VIEW_AND_ACTION_GROUP: 12289,
  CUSTOMER_ACCOUNT_VIEW_AND_ACTION_ALL: 12290,
  CUSTOMER_ACCOUNT_MANAGE: 12291,
  DEV_TEST: 8192,
  GRAY_ORBAC_SERVICE: 8193,
  GRAY_OFFLINE_PUB_SECURITY: 8194,
  GRAY_WORKBENCH: 8195,
  GRAY_COST_REPORT: 8196,
  GRAY_IO_MANAGEMENT: 8197,
  GRAY_ORDER_FUSION: 8198,
  GRAY_CHECK_NEW_CUSTOM: 8224, // 新客查询工具 灰度全选
  GRAY_SALES_NEW_CUSTOM: 8225, // 有效新客灰度
  TEMP_MANAGE_SALE_EMPLOYEE: 8199,
  GRAY_NEIGHBOURHOOD_WECHAT: 8200,
  GRAY_GDT_PROTECTION: 8201,
  GRAY_QIDIAN_ROLES: 8208,
  GRAY_LEAD_RELEASE_AUTOCONFIGURATION: 8209,
  GRAY_POTENTIAL_RELEASE_AUTOCONFIGURATION: 8210,
  GRAY_POTENTIAL_HIGHSEA_AUTOCONFIGURATION: 8211,
  GRAY_LEAD_HIGHSEA_AUTOCONFIGURATION: 8212,
  GRAY_ONLINE_SALES_AGENCY_BIND: 8213,
  GRAY_ONLINE_SALES_EMPLOYEE_BIND: 8214,
  GRAY_CALL_CENTER_DIAL_OUT_RELATION_LEAD: 8215,
  GRAY_HIGH_SEAS_MANAGE_DISTRIBUTE_AGENCY: 8216,
  GRAY_POTENTIAL_HIGH_SEAS_SILENT: 8217, // 商机公海灰度权限码, 用来判断是否区分沉默线索
  GRAY_SEAS_RULE_SET: 8226, // 规则管理 服务商系统可以配置系统分配线索规则设置
  GRAY_SEAS_LEAD_PROMOTE: 8227, // 推广经验灰度 GRAY_LEAD_COMPETITORS_TAG: 8227,
  GRAY_SEAS_HOME_SALE_DATA: 8228, // 灰度 首页展示的销售模块 8228,
  GRAY_OPEN_ACCPOUNT: 8229, // 灰度 开户流程改造 8229
  GRAY_SALE_ACCOUNT_RELATION: 81924, // 灰度 销售人户管理
  GRAY_HHR_ORDER: 81926, // 灰度 合伙人工单入口
  OPS_FREE_DEPRECATED: 65535,
  OPS_AUTHORIZED_DEPRECATED: 65536,
  OPS_REPORT: 65537,
  OPS_REPORT_TODO_ITEMS: 65570,
  OPS_REPORT_SALES_STATISTICS_PERSONAL: 65571,
  OPS_REPORT_SALES_STATISTICS_TEAM: 65572,
  OPS_REPORT_ADV: 65544,
  OPS_REPORT_ADV_VIEW: 65538,
  OPS_REPORT_ADV_DOWNLOAD: 65539,
  OPS_REPORT_AGENCY: 65545,
  OPS_REPORT_AGENCY_OWNERSHIP_VIEW: 65540,
  OPS_REPORT_AGENCY_PERF_VIEW: 65541,
  OPS_REPORT_AGENCY_BASE_VIEW: 65542,
  OPS_REPORT_AGENCY_BASE_DOWNLOAD: 65543,
  OPS_ADV: 67545,
  OPS_ADV_GDT_ACC: 67546,
  OPS_ADV_GDT_ACC_VIEW: 65547,
  OPS_ADV_GDT_NEW_ACC: 65548,
  OPS_ADV_GDT_ACC_PFL: 65550,
  OPS_ADV_GDT_ACC_DOWNLOAD: 65551,
  OPS_ADV_GDT_AD_VIEW: 65552,
  OPS_ADV_GDT_AD_PFL: 65553,
  OPS_ADV_GDT_AD_DOWNLOAD: 65554,
  OPS_ADV_YYB: 65549,
  OPS_ADV_MP: 67547,
  OPS_ADV_MP_ACC_SUMMARY: 67548,
  OPS_ADV_MP_ACC_VIEW: 65555,
  OPS_ADV_MP_ACC_DETAILS: 65556,
  OPS_ADV_MP_NEW_ACC: 67537,
  OPS_ADV_MP_ACC_UNBIND: 67538,
  OPS_ADV_MP_ACC_DOWNLOAD: 67539,
  OPS_ADV_MP_AD_VIEW: 67540,
  OPS_ADV_MP_AD_PFL: 67541,
  OPS_ADV_MP_AD_DOWNLOAD: 67542,
  OPS_ADV_MP_BINDING_VIEW: 67543,
  OPS_ADV_MP_BINDING_DOWNLOAD: 67544,
  OPS_FINANCIAL_VIEW: 65557,
  OPS_FINANCIAL_CHARGE: 65558,
  OPS_FINANCIAL_TRANSFER: 65559,
  OPS_FINANCIAL_TRANSFER_BACK: 65560,
  OPS_BD_CRM_VIEW: 65567,
  OPS_BD_CRM_MANAGE: 65568,
  OPS_BD_RELATIONSHIP_MANAGE: 65569,
  OPS_IM_VIEW: 65577,
  OPS_IM_DELETE: 65578,
  OPS_IM_MARK: 65579,
  OPS_INVOICE_APPLY: 65587,
  OPS_INVOICE_APPLY_VIEW: 65588,
  OPS_INVOICE_PERM_RETAINS: 65589,
  OPS_AGENCY_ACC_MANAGE: 65597,
  OPS_BD_STRATEGY_VIEW: 65607,
  OPS_MP_AGENCY_BINDING_MANAGE: 65617,
  OPS_BACKEND: 76540,
  OPS_BACKEND_ROLE: 76541,
  OPS_BACKEND_ROLE_VIEW: 65636,
  OPS_BACKEND_MDM_BOSS_VIEW: 65637,
  OPS_BACKEND_MDM_ADMIN_EDIT: 65638,
  OPS_BACKEND_MDM_TREASURER_EDIT: 65639,
  OPS_BACKEND_MDM_OBSERVER_EDIT: 65640,
  OPS_BACKEND_MDM_OPERATOR_EDIT: 65641,
  OPS_BACKEND_AGENCY_OPERATOR_EDIT: 65642,
  OPS_BACKEND_BOSS_EDIT: 76537,
  OPS_BACKEND_ADMIN_EDIT: 65643,
  OPS_BACKEND_OBSERVER_EDIT: 65644,
  OPS_BACKEND_TREASURER_EDIT: 65645,
  OPS_BACKEND_SELF_OPERATOR_EDIT: 65646,
  OPS_BACKEND_KPI: 76542,
  OPS_BACKEND_KPI_VIEW: 76538,
  OPS_BACKEND_KPI_EDIT: 76539,
  OPS_REGISTRATION_TICKET_MANAGE: 77825,
  OPS_REGISTRATION_TICKET_ASSIGN_REVIEW: 77826,
  OPS_REGISTRATION_TICKET_REGISTER: 77827,
  OPS_REGISTRATION_TICKET_VIEW_ALL: 77828,
  OPS_REGISTRATION_TICKET_VIEW_SELF: 77829,
  ORGANIZATION_TEAM_ADD: 40000000,
  ORGANIZATION_TEAM_EDIT: 40000001,
  ORGANIZATION_TEAM_DELETE: 40000002,
  ORGANIZATION_TEAM_TRANSFER: 40000003,
  ORGANIZATION_EMPLOYEE_ADD: 50000000,
  ORGANIZATION_EMPLOYEE_TRANSFER: 50000003,
  ORGANIZATION_EMPLOYMENT_RECORD_EDIT: 50000004,
  ORGANIZATION_EMPLOYEE_QUIT: 50000005,
  ORGANIZATION_PROPERTY_MANAGE: 60000001,
  ORGANIZATION_ACTIVITY_MANAGE_VIEW: 60000002,
  ORGANIZATION_ACTIVITY_MANAGE_EDIT: 60000003,
  ORGANIZATION_ONLINE_SALES_VIEW: 60000004,
  ORGANIZATION_MATERIAL_EDIT: 60000005,
  ORGANIZATION_MATERIAL_VIEW: 60000006,
  PERM_SALES_PERFORMANCE_TARGET_OA_VIEW_SELF: 60000007, // oa 域 查看我的服务商业绩目标
  PERM_SALES_PERFORMANCE_TARGET_OA_VIEW_ALL: 60000008, // oa 域 查看全部服务商业绩目标
  PERM_SALES_PERFORMANCE_TARGET_OA_SET: 60000009, // oa 域 设置可查看范围的服务商业绩目标
  PERM_VALID_NEW_CUSTOMER_TARGET_OA_VIEW_SELF: 60000011, // 业绩管理-有效新客业绩-查看我的服务商业绩
  PERM_VALID_NEW_CUSTOMER_TARGET_OA_VIEW_ALL: 60000012, // 业绩管理-有效新客业绩-查看全部服务商业绩
  PERM_VALID_NEW_CUSTOMER_TARGET_OA_SET: 60000013, // 业绩管理-有效新客业绩设置
  PERM_CALL_CENTER_MANAGER: 60000010, // 呼叫中心管理
  PERM_PARTNER_DASHBOARD: 81923, // 城市攻坚看板
  all_leads: [4608, 4609, 4610, 4611, 4612, 4613, 4624, 4640, 4641, 4642, 4656, 4672, 4673, 4674, 4675, 4688, 4689, 4690, 4691, 4692, 4693, 4694, 4695, 4696, 4697, 4704, 4705],
  all_potentials: [4864, 4865, 4866, 4867, 4868, 4880, 4881, 4882, 4896, 4912, 4913, 4914, 4915, 4928, 4929, 4930, 4944, 4945, 4946, 4960, 4961, 4962],
  all_orders: [5120, 5121, 5122, 5136, 5137, 5138, 5139, 5152, 5153, 5154, 5168, 5169, 5170],
  all_reports: [5376, 5392, 5400, 5408, 5424, 5425, 5440, 5441, 5456, 5457, 5473, 5474, 5475, 5476, 5479],
  all_admin: [4352, 4353, 4368, 4369, 4384, 4385, 5632, 5633, 5634, 5635, 5636, 5637, 5638, 5639, 5640, 5641, 40000000, 40000001, 40000002, 40000003, 50000000, 50000003, 50000004, 50000005, 60000001, 60000002, 60000003, 60000004],
  all_sysadmin: [4096, 4112, 4113, 4114, 4115, 4128],
  all_registration: [77825, 77826, 77827, 77828, 77829],
  all_materials: [6150, 6151, 6152, 6153, 60000005, 60000006],
  all_sales_performance_target: [6400, 6401],
  all_ops: [
    65535,
    65536,
    65537,
    65570,
    65571,
    65572,
    65544,
    65538,
    65539,
    65545,
    65540,
    65541,
    65542,
    65543,
    67545,
    67546,
    65547,
    65548,
    65550,
    65551,
    65552,
    65553,
    65554,
    65549,
    67547,
    67548,
    65555,
    65556,
    67537,
    67538,
    67539,
    67540,
    67541,
    67542,
    67543,
    67544,
    65557,
    65558,
    65559,
    65560,
    65567,
    65568,
    65569,
    65577,
    65578,
    65579,
    65587,
    65588,
    65589,
    65597,
    65607,
    65617,
    76540,
    76541,
    65636,
    65637,
    65638,
    65639,
    65640,
    65641,
    65642,
    76537,
    65643,
    65644,
    65645,
    65646,
    76542,
    76538,
    76539,
    77825,
    77826,
    77827,
    77828,
    77829,
  ],
};
